import CodeBlock from './CodeBlock.vue';
import CollapsableContent from './CollapsableContent.vue';
import ContentSection from './ContentSection.vue';
import NoData from './NoData.vue';
import Separator from './Separator.vue';
import Tabs from './Tabs.vue';

export default [
  CodeBlock,
  CollapsableContent,
  ContentSection,
  NoData,
  Separator,
  Tabs,
];
